<script>
    import { onMount, beforeUpdate, afterUpdate, createEventDispatcher } from "svelte";
    import {textify_path} from "./Utils";
    import viewport from "./ViewportAction";
    import {humanFileSize} from "../../class/Utils";
    import { t } from "../../i18n";

    let dispatch = createEventDispatcher();

    export let path = "";
    export let title = null;
    export let content = [];
    export let filesUploading = [];

    let domChats = {};

    let divContent;
    let autoscroll;
    beforeUpdate(() => autoscroll = divContent && divContent.offsetHeight + divContent.scrollTop > divContent.scrollHeight - 20);
    afterUpdate(() => autoscroll && divContent.scrollTo(0, divContent.scrollHeight));
    onMount(() => divContent.scrollTo(0, divContent.scrollHeight));


    let onDomEnterViewport = function(elem){
        if(!elem ||!elem.getAttribute)return;
        if(!elem.classList.contains('chat-unread'))return;
        elem.classList.remove('chat-unread');
        let id = elem.getAttribute('data-id'); if(!id)return;
        dispatch('chatRead', id);
    }
</script>


<style>
    .files-uploading-container{background: #f3f8fd; padding: 4px; border-radius: 2px;}
    .files-uploading-container h3{ font-size: 1.11em; }
    .files-uploading-container div.file{ border-top: 1px dotted #ababab57; margin: 2px 0; text-align: left; background: #ffffffab; }
    .files-uploading-container div.file label{ }

    span.chat-author-name{ display: block; text-align: left; color: #828D99; font-size: 0.8rem; margin-left: 2px; }
</style>

<div class="card-body widget-chat-container widget-chat-scroll" style="overflow:auto;" bind:this={divContent}>
    <div class="chat-content">
        <div class="badge badge-pill badge-light-secondary my-1">{$t('chat.talking_in_prefix')}<b><u>{title || textify_path(path, $t)}</u></b>{$t('chat.talking_in_suffix')}</div>
        {#if Array.isArray(content)}
            {#each content as msg}
                <div
                        class="chat {msg.me ? 'chat':'chat-left'} {msg.read ? 'chat-read':'chat-unread'}"
                        data-id={msg.id}
                        bind:this={domChats[msg.id]}
                        use:viewport
                        on:enterViewport={(e) => onDomEnterViewport(e.target)}
                >
                    <div class="chat-body">

                        {#if msg.userName && !msg.me && msg.userName !== '?'}
                            <span class="chat-author-name">{$t('chat.says_prefix')}<b>{msg.userName || '???'}</b>{$t('chat.says_suffix')}</span>
                        {/if}

                        <div class="chat-message">
                            <p>{msg.msg || ''}</p>
                            <span class="chat-time">{msg.time || ''}</span>
                        </div>
                    </div>
                </div>
            {/each}

            {#if filesUploading && filesUploading.length}
                <div class="files-uploading-container">
                    <label>{$t('chat.uploading')}</label>
                    {#each filesUploading as file}
                        <div class="file"><label>{file.name}</label> - <small>({humanFileSize(file.size||0)})</small> - {file.status}</div>
                    {/each}
                </div>
            {/if}

        {:else}
            <div style="color:red;"><b>{$t('common.error')}</b>: {$t('chat.bad_response')}</div>
        {/if}
    </div>

</div>
